// Auth ekranları için ortak layout — sol brand + sağ form.
// Login, Forgot, ResetPassword, FirstLogin ekranları bunu kullanır (§4.1).

import type { ReactNode } from "react";

interface Props {
  pitch?: string;
  children: ReactNode;
}

export function AuthShell({ pitch, children }: Props): JSX.Element {
  return (
    <main
      className="min-h-screen grid grid-cols-1 md:grid-cols-2"
      style={{ background: "var(--color-bg)" }}
    >
      {/* Sol — brand panel */}
      <aside
        className="hidden md:flex flex-col justify-between p-12"
        style={{ background: "var(--color-dark)", color: "var(--color-text)" }}
      >
        <div>
          <img
            src="/Mahir_logo.png"
            alt="Mahir AI"
            style={{ height: 64, width: "auto", display: "block" }}
          />
          <p
            className="mt-4 text-lg max-w-md"
            style={{ color: "var(--color-text-2)", fontFamily: "var(--font-sans)" }}
          >
            {pitch ??
              "Sürdürülebilirlik raporlamasını 8-15 saate indirir. GRI, TSRS, BM Global Compact ve fazlası."}
          </p>
        </div>
        <footer
          style={{
            color: "var(--color-text-3)",
            fontFamily: "var(--font-mono)",
            fontSize: "0.75rem",
          }}
        >
          v0.0 · dev
        </footer>
      </aside>

      {/* Sağ — form */}
      <section className="flex items-center justify-center p-8 md:p-16">
        <div className="w-full max-w-md" style={{ fontFamily: "var(--font-sans)" }}>
          {children}
        </div>
      </section>
    </main>
  );
}
